import React, { Component } from "react";
import "./Sidebar.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Chart } from "primereact/chart";
import ScanQRService from "../../src/services/ScanQRService";
import tableRequest from "../models/tableRequest";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dropdown } from "primereact/dropdown";
import mapped from "../assets/mapped.gif";

import demapped from "../assets/demapped.gif";
import damage from "../assets/damage.gif";
import nongenuine from "../assets/non-genuine.gif";
import genuine from "../assets/genuine.gif";
import "./Dashboard.scss";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import totalMapped from "../assets/connection.gif";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.ScanQRService = new ScanQRService();
    this.tblResponse = new tableRequest();
    this.GetDashBoardData = this.GetDashBoardData.bind(this);

    // this.state = {
    //   totalMapped: "",
    //   totalDemapped: "",
    //   totalDamaged: "",
    // };
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    // const format = (d) => d.toISOString().split("T")[0];
    const format = (d) => {
      return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
        .toISOString()
        .split("T")[0];
    };
    this.state = {
      totalMapped: 0,
      totalDemapped: 0,
      totalDamaged: 0,
      totalGenuine: 0,
      totalNonGenuine: 0,
      loadingDashboard: true,
      loadingUser: false,
      users: [],
      selectedUser: null,
      userMapping: 0,
      userDeMapping: 0,
      userGenuineMapping: 0,
      userNongenuineMapping: 0,
      userDamage: 0,
      userType: Number(sessionStorage.getItem("userType")),
      fromDate: format(firstDay),
      toDate: format(lastDay),
    };
  }

  componentDidMount() {
    this.tblResponse.UserId = sessionStorage.getItem("UserId");
    this.tblResponse.UserType = sessionStorage.getItem("userType");
    console.log("UserType:", sessionStorage.getItem("userType"));

    this.GetDashBoardData();

    const userType = Number(sessionStorage.getItem("userType"));
    const userId = Number(sessionStorage.getItem("UserId"));

    // Load user-wise data for both admin and regular users
    // All users call LoadUserWiseData with their user ID to get the users list and stats
    this.setState({ selectedUser: userId }, () => {
      this.LoadUserWiseData(userId, this.state.fromDate, this.state.toDate);
    });
  }

  GetDashBoardData() {
    this.setState({ loadingDashboard: true });
    const userType = Number(sessionStorage.getItem("userType"));
    const userId = sessionStorage.getItem("UserId");
    const formData = {
      pageNo: 1,
      searchValue: "",
      pageSize: -1,
      sortColumn: "",
      sortOrder: "DESC",
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      userId: 0, // Always get global data for all users
      userType: 1, // Use admin userType to query global data
    };

    this.ScanQRService.GetDashBoardData(formData)
      .then((res) => {
        const data = res.data?.ResponseData?.DashboardCount;
        if (data) {
          this.setState({
            totalMapped: (data.TotalGenuine || 0) + (data.TotalNonGenuine || 0), // sum genuine + non-genuine
            totalDemapped: data.TotalDeMapping || 0,
            totalDamaged: data.TotalDamage || 0,
            totalGenuine: data.TotalGenuine || 0,
            totalNonGenuine: data.TotalNonGenuine || 0,
            loadingDashboard: false,
          });

          console.log("Dashboard state updated with:", {
            totalMapped: data.TotalMapping,
            totalDemapped: data.TotalDeMapping,
            totalDamaged: data.TotalDamage,
            totalGenuine: data.TotalGenuine,
            totalNonGenuine: data.TotalNonGenuine,
          });
        } else {
          // Safe fallback if API returns no data
          this.setState({
            totalMapped: 0,
            totalDemapped: 0,
            totalDamaged: 0,
            totalGenuine: 0,
            totalNonGenuine: 0,
            loadingDashboard: false,
          });
        }

        this.setState({ loading: false });
      })
      .catch((err) => {
        console.error("GetDashBoardData error:", err);
        this.setState({
          totalMapped: 0,
          totalDemapped: 0,
          totalDamaged: 0,
          totalGenuine: 0,
          totalNonGenuine: 0,
          loadingDashboard: false,
          loading: false,
        });
      });
  }

  LoadUserWiseData(userId, fromDate, toDate) {
    this.setState({ loading: true });
    // First call without dates to get users list, then call with dates to get summary
    // This ensures users always show in dropdown even if they have no transactions in date range
    this.ScanQRService.GetUserWiseDashboard(userId, null, null)
      .then((res) => {
        const responseData = res.data?.ResponseData;
        console.log("FULL API RESPONSE:", res.data);
        console.log("ResponseData:", responseData);
        console.log("Users object:", responseData?.Users);

        console.log(
          "LoadUserWiseData response for userId:",
          userId,
          responseData,
        );

        if (!responseData) {
          this.setState({
            users: [],
            userMapping: 0,
            userDeMapping: 0,
            userDamage: 0,
            loading: false,
          });
          return;
        }

        // Filter out inactive users and exclude specific users from the dropdown
        const usersList =
          responseData?.Users ||
          responseData?.users ||
          responseData?.UserList ||
          [];

        console.log("Users List After Extraction:", usersList);

        const formattedUsers = usersList.map((u) => ({
          UserId: u.UserId ?? u.userId ?? u.id,
          UserName: u.UserName ?? u.userName ?? u.name,
          IsActive: u.IsActive ?? u.isActive ?? true,
        }));

        const activeUsers = formattedUsers.filter(
          (user) => user.IsActive !== false,
        );

        this.setState({ users: activeUsers });

        this.setState({ users: activeUsers });

        // For regular users, auto-select first user if none selected
        if (!this.state.selectedUser && activeUsers?.length > 0) {
          const firstUserId = activeUsers[0].UserId;
          this.setState({ selectedUser: firstUserId }, () => {
            // Get summary WITH date filter
            this.LoadUserSummary(firstUserId, fromDate, toDate);
          });
          return;
        }

        // Get summary WITH date filter for currently selected user
        this.LoadUserSummary(userId, fromDate, toDate);
      })
      .catch((err) => {
        console.error("Error loading user data:", err);
        this.setState({ loading: false });
      });
  }

  LoadUserSummary(userId, fromDate, toDate) {
    // Fetch summary data with date filter
    this.ScanQRService.GetUserWiseDashboard(userId, fromDate, toDate)
      .then((res) => {
        const responseData = res.data?.ResponseData;
        const summary = responseData?.Summary;

        console.log("Summary for userId:", userId, summary);

        // Calculate total mapping as sum of Genuine + Non-Genuine
        const genuine = summary?.GenuineMappingCount || 0;
        const nongenuine = summary?.NonGenuineMappingCount || 0;

        this.setState({
          userGenuineMapping: genuine,
          userNongenuineMapping: nongenuine,
          userMapping: genuine + nongenuine, // ✅ Correct total mapping count
          userDeMapping: summary?.DeMappingCount || 0,
          userDamage: summary?.DamageCount || 0,
          loading: false,
        });
      })
      .catch((err) => {
        console.error("Error loading user summary:", err);
        this.setState({ loading: false });
      });
  }

  onUserChange = (e) => {
    this.setState({ selectedUser: e.value });
    this.LoadUserSummary(e.value, this.state.fromDate, this.state.toDate);
  };

  // Format helper
  formatDate = (date) => date.toISOString().split("T")[0];

  // Apply Date Filter
  applyDateFilter = () => {
    const { fromDate, toDate, selectedUser } = this.state;

    if (!fromDate || !toDate) {
      alert("Please select both From & To dates.");
      return;
    }

    this.GetDashBoardData();

    if (selectedUser != null) {
      this.LoadUserSummary(Number(selectedUser), fromDate, toDate);
    }
  };

  // Reset Date Filter to "This Month"
  resetDateFilter = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const resetFrom = this.formatDate(firstDay);
    const resetTo = this.formatDate(today);

    this.setState(
      {
        fromDate: this.formatDate(firstDay),
        toDate: resetTo,
      },
      () => {
        this.GetDashBoardData();

        if (this.state.selectedUser != null) {
          this.LoadUserWiseData(
            Number(this.state.selectedUser),
            this.state.fromDate,
            this.state.toDate,
          );
        }
      },
    );
  };

  render() {
    // ------------------------------
    // NEW: BAR CHART DATA & OPTIONS
    // ------------------------------
    const barData = {
      labels: ["Mapping", "De-Mapping", "Damage"],
      datasets: [
        {
          label: "Transaction Count",
          data: [
            this.state.totalMapped,
            this.state.totalDemapped,
            this.state.totalDamaged,
          ],
          backgroundColor: ["#f7b924", "#007bff", "#dc3545"],
        },
      ],
    };

    const barOptions = {
      chart: {
        type: "column",
        height: 320,
        backgroundColor: "transparent",
        spacingBottom: 0,
      },

      title: {
        margin: 40,

        text: "Genuine vs Non-Genuine Stock",
        style: {
          fontSize: "18px",
          fontWeight: "600",
          color: "#333",
        },
      },

      legend: { enabled: true },

      xAxis: {
        categories: ["Stock Status"],
        labels: {
          style: {
            fontSize: "14px",
            fontWeight: "600",
            color: "#333",
          },
        },
        lineColor: "#e0e0e0",
      },

      yAxis: {
        min: 0,
        title: { text: "" },
        gridLineColor: "#e6e6e6",
        labels: {
          style: { color: "#495057" },
        },
      },

      tooltip: {
        shared: true,
        pointFormat:
          '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          borderRadius: 6,
          animation: { duration: 2000 },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "15px",
              fontWeight: "700",
              color: "#222",
              textOutline: "none",
            },
          },
        },
      },

      credits: { enabled: false },

      series: [
        {
          name: "Non-Genuine",

          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, "#FF7070"],
              [1, "#E64545"],
            ],
          },
          data: [
            this.state.userType === 1
              ? this.state.totalNonGenuine
              : this.state.userNongenuineMapping || 0,
          ],
        },
        {
          name: "Genuine",

          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, "#4CAF50"],
              [1, "#2E7D32"],
            ],
          },
          data: [
            this.state.userType === 1
              ? this.state.totalGenuine
              : this.state.userGenuineMapping || 0,
          ],
        },
      ],
    };
    const pieOptions = {
      chart: {
        height: 320,
        type: "pie",
        backgroundColor: "transparent",
        spacingRight: 0,
      },

      title: {
        text: "Hologram Stock Status",
        verticalAlign: "top",
        style: {
          fontSize: "18px",
          fontWeight: "600",
          color: "#333",
        },
      },

      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle",
        itemMarginTop: 8,
        itemMarginBottom: 8,
        floating: true,
        symbolRadius: 6,
        symbolHeight: 14,
        x: -30,
        symbolWidth: 14,
        itemStyle: {
          fontSize: "13px",
          fontWeight: "600",
          color: "#333",
        },
      },

      tooltip: {
        headerFormat: "",
        pointFormat:
          '<span style="color:{point.color}">\u25cf</span> <b>{point.name}</b>: ({point.percentage:.1f}%)',
        backgroundColor: "#ffffff",
        borderColor: "transparent",
        borderRadius: 8,
        shadow: true,
        style: {
          fontSize: "13px",
          color: "#333",
        },
      },

      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          borderWidth: 1,
          borderRadius: 5,
          borderColor: "#ffffff",
          innerSize: "55%",
          size: "100%",
          // startAngle: -50,
          slicedOffset: 12,
          center: ["40%", "50%"],

          dataLabels: {
            enabled: true,
            distance: -25,
            style: {
              fontSize: "12px",
              fontWeight: "700",
              textOutline: "none",
              color: "#fff",
            },
            formatter: function () {
              return `${this.point.percentage.toFixed(1)}%`;
            },
          },

          shadow: {
            color: "rgba(0,0,0,0.15)",
            offsetX: 0,
            offsetY: 4,
          },
        },
      }, // ← FIXED missing bracket here

      responsive: {
        rules: [
          {
            condition: { maxWidth: 400 },
            chartOptions: {
              legend: {
                align: "center",
                verticalAlign: "bottom",
                layout: "horizontal",
              },
              plotOptions: {
                pie: { center: ["50%", "30%"], size: "70%" },
              },
            },
          },
        ],
      },

      credits: { enabled: false },

      series: [
        {
          name: "Stock",
          showInLegend: true,
          animation: { duration: 2000 },

          data: [
            {
              name: "Mapped",
              y:
                this.state.userType === 1
                  ? this.state.totalMapped
                  : this.state.userMapping,
              color: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                stops:
                  this.state.userType === 1
                    ? [
                        [0, "rgb(46, 113, 222)"],
                        [1, "rgb(57, 96, 224)"],
                      ]
                    : [
                        [0, "#4CAF50"],
                        [1, "#2E7D32"],
                      ],
              },
            },
            {
              name: "Demapped",
              y:
                this.state.userType === 1
                  ? this.state.totalDemapped
                  : this.state.userDeMapping,
              color: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                stops:
                  this.state.userType === 1
                    ? [
                        [0, "#ffc764"],
                        [1, "#ff9e2b"],
                      ]
                    : [
                        [0, "#FF9800"],
                        [1, "#F57C00"],
                      ],
              },
            },
            {
              name: "Damaged",
              y:
                this.state.userType === 1
                  ? this.state.totalDamaged
                  : this.state.userDamage,
              color: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                stops:
                  this.state.userType === 1
                    ? [
                        [0, "#ff7070"],
                        [1, "#e64545"],
                      ]
                    : [
                        [0, "#E53935"],
                        [1, "#B71C1C"],
                      ],
              },
            },
          ],
        },
      ],
    };

    const lineOptions = {
      chart: {
        type: "bar", // HORIZONTAL GRAPH
        backgroundColor: "transparent",
        height: 350,
        spacingTop: 40,
      },

      title: {
        margin: 20,
        text: "User Wise Stats",
        style: {
          fontSize: "18px",
          fontWeight: "600",
          color: "#333",
        },
      },

      xAxis: {
        categories: ["Mapping", "DeMapping", "Damage"],
        title: null,
        labels: {
          style: { color: "#495057", fontWeight: 500 },
        },
      },

      yAxis: {
        min: 0,
        title: null,
        gridLineColor: "#ebedef",
        labels: { style: { color: "#495057" } },
      },

      legend: {
        enabled: true,
        symbolHeight: 12,
        symbolWidth: 12,
        y: 20,
        itemStyle: { color: "#333", fontWeight: 500 },
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          const index = this.point.index;

          if (index === 0) {
            // Mapping → include Genuine & Non-Genuine
            return `
              <div style="padding:4px 8px">
                <b>Mapping:</b> ${this.y}<br/>
                <span style="color:#4CAF50">●</span> Genuine: <b>${lineOptions.genuine}</b><br/>
                <span style="color:#FF5252">●</span> Non-Genuine: <b>${lineOptions.nongenuine}</b>
              </div>
            `;
          }

          return `<b>${this.point.category}:</b> ${this.y}`;
        },
      },

      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "14px",
              fontWeight: "600",
              color: "#333",
            },
          },
          borderRadius: 5,
        },
      },

      series: [
        {
          name: "User Stats",
          legendType: "point",
          showInLegend: true,

          data: [
            {
              name: "Mapping",
              y: this.state.userMapping,
              color: "rgb(236, 211, 21)",
              showInLegend: true,
            },
            {
              name: "DeMapping",
              y: this.state.userDeMapping,
              color: "rgb(134, 14, 194)",
              showInLegend: true,
            },
            {
              name: "Damage",
              y: this.state.userDamage,
              color: "#E53935",
              showInLegend: true,
            },
          ],
        },
      ],

      credits: { enabled: false },
    };

    lineOptions.genuine = this.state.userGenuineMapping;
    lineOptions.nongenuine = this.state.userNongenuineMapping;

    return (
      <>
        <div className="date-inline-filter mb-4 mt-4">
          {/* FROM */}
          <div className="date-item">
            <span className="date-label">From:</span>
            <input
              type="date"
              className="date-input"
              value={this.state.fromDate}
              max={this.state.toDate}
              onChange={(e) => this.setState({ fromDate: e.target.value })}
            />
          </div>

          {/* SWAP ICON */}
          <span className="swap-icon">↔</span>

          {/* TO */}
          <div className="date-item">
            <span className="date-label">To:</span>
            <input
              type="date"
              className="date-input"
              value={this.state.toDate}
              min={this.state.fromDate}
              onChange={(e) => this.setState({ toDate: e.target.value })}
            />
          </div>
          <button
            className="date-btn apply-btn"
            onClick={() => this.applyDateFilter()}
          >
            Apply
          </button>

          {/* RESET BUTTON */}
          <button
            className="date-btn reset-btn"
            onClick={() => this.resetDateFilter()}
          >
            Reset
          </button>
        </div>
        {this.state.loading && (
          <div className="loader-overlay">
            <div class="middle">
              <div class="bar bar1"></div>
              <div class="bar bar2"></div>
              <div class="bar bar3"></div>
              <div class="bar bar4"></div>
              <div class="bar bar5"></div>
              <div class="bar bar6"></div>
              <div class="bar bar7"></div>
              <div class="bar bar8"></div>
            </div>
          </div>
        )}

        <div
          className="d-flex stats-row"
          style={{
            flexWrap: "nowrap",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          {[
            ...(this.state.userType !== 1
              ? [
                  {
                    label: "Total Mapped",
                    value: this.state.totalMapped || 0,
                    img: totalMapped,
                  },
                ]
              : []),

            {
              label: "Mapping",
              value:
                this.state.userType === 1
                  ? this.state.totalGenuine + this.state.totalNonGenuine // sum for admin users
                  : this.state.userMapping,
              img: mapped,
            },

            {
              label: "De Mapping",
              value:
                this.state.userType === 1
                  ? this.state.totalDemapped
                  : this.state.userDeMapping,
              img: demapped,
            },
            {
              label: "Damage",
              value:
                this.state.userType === 1
                  ? this.state.totalDamaged
                  : this.state.userDamage,
              img: damage,
            },
            {
              label: "Genuine",
              value:
                this.state.userType === 1
                  ? this.state.totalGenuine
                  : this.state.userGenuineMapping,
              img: genuine,
            },
            {
              label: "Non-Genuine",
              value:
                this.state.userType === 1
                  ? this.state.totalNonGenuine
                  : this.state.userNongenuineMapping,
              img: nongenuine,
            },
          ].map((item, index) => (
            <div
              className="stat-wrapper"
              key={index}
              style={{
                flex: "1 1 18%",
                minWidth: "150px",
                margin: "5px",
              }}
            >
              <div
                className="stat-card"
                style={{ width: "100%", boxSizing: "border-box" }}
              >
                <div className="stat-icon-box">
                  <img src={item.img} alt={item.label} className="stat-icon" />
                </div>
                <div className="stat-content">
                  <div className="stat-title">{item.label}</div>
                  <div className="stat-value">{item.value || 0}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row mt5">
          {/* LEFT: Cards */}

          {/* RIGHT: Doughnut Chart */}
          <div className="col-md-6 card-box">
            <div className="d-block cards dash-data">
              <HighchartsReact highcharts={Highcharts} options={pieOptions} />
            </div>
          </div>
          <div className="col-md-6 card-box-2">
            <div className="d-block cards dash-data">
              <HighchartsReact highcharts={Highcharts} options={barOptions} />
            </div>
          </div>
        </div>

        {this.state.userType === 1 && (
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="cards dash-data rounded position-relative">
                <div
                  className=" user-select-wrapper"
                  style={{
                    right: "25px",
                    zIndex: 10,
                    paddingBottom: "15px",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <label
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#495057",
                        marginTop: "10px",
                      }}
                    >
                      Select User
                    </label>

                    <Dropdown
                      value={this.state.selectedUser}
                      options={this.state.users}
                      onChange={this.onUserChange}
                      optionLabel="UserName"
                      optionValue="UserId"
                      placeholder="Select User"
                      style={{ textAlign: "left", minWidth: "200px" }}
                      // className="w-100"
                    />
                  </div>
                </div>

                {/* Center Chart */}

                <HighchartsReact
                  highcharts={Highcharts}
                  options={lineOptions}
                />
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
      </>
    );
  }
}
